<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!salvataggioInCorso"
  [dismissableMask]="!salvataggioInCorso"
  [style]="{width: '90vw', maxWidth: '1200px'}"
  styleClass="p-fluid comunica-contributo-dialog"
  [showHeader]="false"
  (onHide)="hide()"
>
  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-credit-card header-icon"></i>
        <h2>Liquidazione intervento</h2>
        <div
          class="code-badge"
          style="
            background-color: #f5f5f5;
            padding: 0.25rem 0.5rem;
            border-radius: 4px;
            margin-left: 1rem;
          "
          *ngIf="intervento?.scheda?.codice"
        >
          <span
            class="code-value"
            style="font-weight: bold; color: #3a6e75;"
            >{{ intervento?.scheda?.codice }}</span
          >
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="salvataggioInCorso"
        (click)="hide()"
      ></button>
    </div>

    <div class="dialog-content">
      <!--<div
        class="p-message p-message-info"
        style="
          margin-bottom: 1rem;
          padding: 1rem;
          background-color: #e0f2fe;
          border-left: 4px solid #0284c7;
          border-radius: 4px;
        "
      >
         <div style="display: flex; align-items: flex-start; gap: 0.75rem;">
          <i
            class="pi pi-info-circle"
            style="color: #0369a1; font-size: 1rem; margin-top: 0.15rem;"
          ></i>
          <div style="font-size: 0.875rem; color: #0f172a;">
            <p style="margin: 0 0 0.25rem 0; font-weight: 600;">
              Stai comunicando la liquidazione di questo intervento.
            </p>
            <p style="margin: 0;">
              La data e l'importo indicati saranno utilizzati per tracciare la
              liquidazione economica associata alla rendicontazione già
              effettuata.
            </p>
          </div>
        </div>
      </div>
 -->
      <div style="display: flex; gap: 1.5rem; flex-wrap: wrap;">
        <div
          style="
            flex: 1 1 240px;
            background: #f8f9fa;
            padding: 1.25rem;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          "
        >
          <label
            for="dataLiquidazione"
            style="
              display: block;
              color: #6c757d;
              font-size: 0.875rem;
              margin-bottom: 0.5rem;
            "
            >Data liquidazione</label
          >
          <input
            id="dataLiquidazione"
            type="date"
            [(ngModel)]="dataLiquidazione"
            style="
              width: 100%;
              padding: 0.5rem 0.75rem;
              border-radius: 4px;
              border: 1px solid #d1d5db;
              font-size: 0.875rem;
            "
            [disabled]="salvataggioInCorso"
          />
        </div>
        <div
          style="
            flex: 1 1 240px;
            background: #f8f9fa;
            padding: 1.25rem;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          "
        >
          <label
            style="
              display: block;
              color: #6c757d;
              font-size: 0.875rem;
              margin-bottom: 0.5rem;
            "
          >
            Importo da liquidare
            <span
              *ngIf="intervento?.importoLiquidato"
              style="font-size: 0.75rem; color: #9ca3af; font-style: italic;"
            >
              (già liquidati {{ intervento?.importoLiquidato | currency:'EUR':'':'1.2-2':'it-IT' }} €)
            </span>
          </label>
          <span
            style="
              display: block;
              font-weight: 600;
              color: #111827;
              font-size: 0.95rem;
            "
          >
            {{ importoLiquidato | currency:'EUR':'':'1.2-2':'it-IT' }}
          </span>
        </div>
      </div>

      <div class="field" style="margin-top: 1.5rem;">
        <label for="noteLiquidazione">Note</label>
        <textarea
          id="noteLiquidazione"
          pInputTextarea
          [(ngModel)]="note"
          [rows]="3"
          [cols]="30"
          [style]="{'width': '100%'}"
          placeholder="Inserisci eventuali note (es. Mandato n. 123)"
          [disabled]="salvataggioInCorso">
        </textarea>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        [disabled]="salvataggioInCorso"
        (click)="hide()"
      ></button>
      <button
        pButton
        pRipple
        label="Conferma liquidazione"
        icon="pi pi-check"
        class="p-button-success"
        (click)="confermaLiquidazione()"
        [disabled]="!dataLiquidazione || salvataggioInCorso"
      ></button>
    </div>
  </div>
</p-dialog>

